module.exports = __webpack_public_path__ + "static/js/ocapi-asambeauty.9405a349.js";